import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import ReactPlayer from 'react-player';

const BannerWithText = ({ block }) => {
  const media = block.primary.media;
  const mediaMobile = block?.primary?.media_mobile;
  const mediaAltText = block?.primary?.media_alt_text;
  const title = block.primary.banner_title[0].text;
  const description = block.primary.banner_description[0].text;
  const link = block.primary.banner_link;

  return (
    <>
      <div className="content-wrapper">
        {media?.url && (
          <Link href={link ? link : '#'}>
            <a className="banner-wrapper">
              {media.kind === 'image' ? (
                <div className="image-wrapper">
                  <Image
                    src={media?.url}
                    layout="fill"
                    objectFit="cover"
                    alt={mediaAltText ? mediaAltText : title}
                  />
                </div>
              ) : (
                <ReactPlayer
                  url={media?.url}
                  width="100%"
                  height="100%"
                  playing={true}
                  loop={true}
                  muted={true}
                  controls={false}
                  className="video-wrapper"
                />
              )}
            </a>
          </Link>
        )}
        {mediaMobile?.url && (
          <Link href={link ? link : '#'}>
            <a className="mobile-banner-wrapper">
              {mediaMobile?.kind === 'image' ? (
                <div className="mobile-image-wrapper">
                  <Image
                    src={mediaMobile?.url}
                    width={mediaMobile?.width}
                    height={mediaMobile?.height}
                    alt={mediaAltText ? mediaAltText : title}
                  />
                </div>
              ) : (
                <ReactPlayer
                  url={mediaMobile?.url}
                  width="100%"
                  height="100%"
                  playing={true}
                  loop={true}
                  muted={true}
                  controls={false}
                  className="video-wrapper"
                />
              )}
            </a>
          </Link>
        )}
        <div className="text-wrapper">
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
      </div>

      <style jsx>{`
        .content-wrapper {
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background-color: #0f0f0f;
        }
        .banner-wrapper {
          width: 100%;
          max-width: 1440px;
          height: ${media.kind === 'image' ? '600px' : '500px'};
          position: relative;
          overflow: hidden;
          display: grid;
          align-items: center;
        }
        .mobile-banner-wrapper {
          display: none;
        }
        .image-wrapper,
        .video-wrapper {
          grid-area: 1 / 1 / 2 / 2;
          width: 100%;
          height: 100%;
        }
        .image-wrapper img,
        .video-wrapper {
          object-fit: cover;
          object-position: start;
        }
        .text-wrapper {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          padding: 20px;
          font-family: 'big_noodle_titling';
          text-align: left;
          max-width: 1440px;
        }
        h1 {
          font-size: 96px;
          margin: 10px 0;
          color: #ffffff;
          line-height: 105.89px;
        }
        p {
          font-size: 32px;
          color: #707070;
          margin: 0;
          line-height: 35.3px;
          letter-spacing: 0.09em;
          text-align: left;
        }
        @media (max-width: 430px) {
          .banner-wrapper {
            display: none;
          }
          .mobile-banner-wrapper {
            display: grid;
            width: 100%;
            height: auto;
            position: relative;
            overflow: hidden;
            align-items: center;
          }
          .text-wrapper {
            text-align: center;
            padding: 0 20px;
          }
          h1 {
            font-size: 48px;
            line-height: 52px;
          }
          p {
            font-size: 20px;
            line-height: 22px;
          }
        }
      `}</style>
    </>
  );
};

export default BannerWithText;
